import { Box, Typography, styled, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { getFormattedLastSavedAt } from 'pages/Remixer/components/Header/components/LastSaveInfo/helpers';
import { selectLastSavedAt } from 'services/store/remixer/selectors';

const StyledTypography = styled(Typography)({
  fontSize: 12,
  lineHeight: '16px',
});

const LastSaveInfo = () => {
  const { t } = useTranslation();
  const theme = useTheme();

  const lastSavedAt = useSelector(selectLastSavedAt);

  const lastSavedAtRenderValue = lastSavedAt
    ? getFormattedLastSavedAt(lastSavedAt)
    : t('remixer:header:never');

  return (
    <Box
      sx={{
        alignItems: 'flex-end',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <StyledTypography sx={{ color: theme.palette.grey[400] }}>
        {t('remixer:header:lastSaved')}
      </StyledTypography>

      <StyledTypography>{lastSavedAtRenderValue}</StyledTypography>
    </Box>
  );
};

export default LastSaveInfo;
